import * as types from './types';

const INITIAL_STATE = {
  itemListingReportData: [],
  loading: false,
  itemListingError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ITEM_LIST_DATA:
      return {
        ...state,
        itemListingReportData: action.payload,
      };

    case types.ITEM_DATA_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.ITEM_DATA_LIST_ERROR:
      return {
        ...state,
        itemListingError: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/state/reducer.js